export default __webpack_public_path__ + "static/media/valeur-exigence.1c0d72ff.jpg";